import TopBanner from './TopBanner';
import Navigation from './Navigation';
import { Outlet } from 'react-router-dom';
import '../App.css';
import '../styles/footer.css';
import Logo from './Logo';

function Layout() {
    return (
        <div className="App">
            <TopBanner />
            <Navigation />
            <Outlet />

            {/* Footer */}
            <footer className="footer">
                <div className="footer-container">
                    {/* Brand / About */}
                    <div className="footer-section">
                        <div className="footer-logo">
                            <Logo />
                        </div>
                        <p className="footer-tagline">
                            Streamline your car rental operations with powerful, easy-to-use tools.
                        </p>
                    </div>

                    {/* Product Links */}
                    <div className="footer-section">
                        <h3>Product</h3>
                        <ul>
                            <li><a href="/product">Overview</a></li>
                            <li><a href="/pricing">Pricing</a></li>
                            <li><a href="/solutions">Solutions</a></li>
                        </ul>
                    </div>

                    {/* Resources Links */}
                    <div className="footer-section">
                        <h3>Resources</h3>
                        <ul>
                            <li><a href="/resources">Blog</a></li>
                            <li><a href="/book-demo">Book a Demo</a></li>
                            <li><a href="/sales">Contact Sales</a></li>
                        </ul>
                    </div>

                    {/* Contact Links */}
                    <div className="footer-section">
                        <h3>Connect</h3>
                        <ul>
                            <li><a href="mailto:info@fleetify.com">info@fleetify.com</a></li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/fleetify"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    LinkedIn
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://twitter.com/fleetify"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Twitter/X
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    &copy; {new Date().getFullYear()} Fleetify. All rights reserved.
                </div>
            </footer>
        </div>
    );
}

export default Layout;
